import React, { useState } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import ItemService from "../../../services/inventory_appCommonService";

//Redux
import {
  isValidNumber,
  validateRequired,
  validateTextArea,
} from "../../../common/Validations";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import { useNavigate } from "react-router-dom";
import WarehouseConstants from "../../../common/WarehouseConstants";

const CreateStock = () => {
  localStorage.setItem("menu", "stock");
  localStorage.setItem("submenu", "stcok-list");
  const navigate = useNavigate();

  const [isCardVisible, setCardVisible] = useState(true);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [disabled, setDisabled] = useState(false);

  const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
      "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
      "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
      "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
    VALID_QUANTITY: "Please enter a valid quantity",
  };

  const [formInputs, setFormInputs] = useState({
    slNo: "",
    stockCode: "",
    productName: "",
    materialName: "",
    quantity: "",
    uOM: "",
    batchNumber: "",
    supplierName: "",
    storageLocation: "",
    stockGroup: "",
    stockDesc: "",
  });

  /* pop failure modal data*/
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureModal] = useState(failureModalData);
  const [validation, setValidation] = useState({
    slNo: "",
    stockCode: "",
    productName: "",
    materialName: "",
    quantity: "",
    uOM: "",
    batchNumber: "",
    supplierName: "",
    storageLocation: "",
    stockGroup: "",
    stockDesc: "",
  });
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
    let error = "";

    if (name === "slNo" && !validateRequired(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }
    if (name === "quantity" && !isValidNumber(value)) {
      error = message.VALID_QUANTITY;
    }
    // Update validation errors
    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  //hide  failur modal
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };
  /* handle create */
  const handleCreate = async () => {
    const requiredFields = [];

    if (!validateRequired(formInputs.slNo)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        slNo: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.stockCode)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        stockCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.productName)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        productName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.materialName)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        materialName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.quantity)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        quantity: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!isValidNumber(formInputs.quantity)) {
      requiredFields.push(message.VALID_QUANTITY);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        quantity: message.VALID_QUANTITY,
      }));
      return;
    }

    if (!validateRequired(formInputs.uOM)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        uOM: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.batchNumber)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        batchNumber: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.supplierName)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        supplierName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.storageLocation)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        storageLocation: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.stockGroup)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        stockGroup: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateTextArea(formInputs.stockDesc)) {
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        stockDesc: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    let obj = {
      data: formInputs,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: "Save",
    };

    await ItemService.addStock(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        navigate(WarehouseConstants.WH_STOCK_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const handleDraft = async () => {
    let obj = {
      data: formInputs,
      type: "Draft",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    await ItemService.addStock(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        navigate(WarehouseConstants.WH_STOCK_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const handleSubmit = async (type) => {
    if (type === "Save") {
      await handleCreate(type);
    } else if (type === "Draft") {
      await handleDraft(type);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Stock</h2>
            <p className="subText">Create Stock</p>
            <hr />
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CM</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Create Stock</span>
                      <span className="subHeaderTitle">Create Stock</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Sl No."
                          label={
                            <>
                              <i className="bi bi-list-ol labelIcon"></i>
                              Sl No.
                            </>
                          }
                          name="slNo"
                          id="slNo"
                          extraLabel=""
                          value={formInputs.slNo || ""}
                          onChange={onInputChange}
                          error={validation.slNo || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Stock Code"
                          label={
                            <>
                              <i className="bi bi-upc-scan labelIcon"></i>
                              Stock Code
                            </>
                          }
                          name="stockCode"
                          id="stockCode"
                          value={formInputs.stockCode || ""}
                          onChange={onInputChange}
                          error={validation.stockCode || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Product Name"
                          label={
                            <>
                              <i className="bi bi-box-seam labelIcon"></i>
                              Product Name
                            </>
                          }
                          name="productName"
                          id="productName"
                          value={formInputs.productName || ""}
                          onChange={onInputChange}
                          error={validation.productName || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Material Name"
                          label={
                            <>
                              <i className="bi bi-box labelIcon"></i>
                              Material Name
                            </>
                          }
                          name="materialName"
                          id="materialName"
                          value={formInputs.materialName || ""}
                          onChange={onInputChange}
                          error={validation.materialName || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Quantity"
                          label={
                            <>
                              <i className="bi bi-123 labelIcon"></i>
                              Quantity
                            </>
                          }
                          name="quantity"
                          id="quantity"
                          value={formInputs.quantity || ""}
                          onChange={onInputChange}
                          error={validation.quantity || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="UOM"
                          label={
                            <>
                              <i className="bi bi-rulers labelIcon"></i>
                              UOM
                            </>
                          }
                          name="uOM"
                          id="uOM"
                          extraLabel=""
                          value={formInputs.uOM || ""}
                          onChange={onInputChange}
                          error={validation.uOM || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Batch Number"
                          label={
                            <>
                              <i className="bi bi-hash labelIcon"></i>
                              Batch Number
                            </>
                          }
                          name="batchNumber"
                          id="batchNumber"
                          value={formInputs.batchNumber || ""}
                          onChange={onInputChange}
                          error={validation.batchNumber || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Supplier Namer"
                          label={
                            <>
                              <i className="bi bi-person-vcard labelIcon"></i>
                              Supplier Name
                            </>
                          }
                          name="supplierName"
                          id="supplierName"
                          value={formInputs.supplierName || ""}
                          onChange={onInputChange}
                          error={validation.supplierName || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Storage Location"
                          label={
                            <>
                              <i className="bi bi-geo-alt labelIcon"></i>
                              Storage Location
                            </>
                          }
                          name="storageLocation"
                          id="storageLocation"
                          value={formInputs.storageLocation || ""}
                          onChange={onInputChange}
                          error={validation.storageLocation || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Stock Group"
                          label={
                            <>
                              <i className="bi bi-collection labelIcon"></i>
                              Stock Group
                            </>
                          }
                          name="stockGroup"
                          id="stockGroup"
                          extraLabel=""
                          value={formInputs.stockGroup || ""}
                          onChange={onInputChange}
                          error={validation.stockGroup || ""}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          // label="Stock Description"
                          label={
                            <>
                              <i className="bi bi-card-text labelIcon"></i>
                              Stock Description
                            </>
                          }
                          type="text"
                          name="stockDesc"
                          id="stockDesc"
                          value={formInputs.stockDesc || ""}
                          onChange={onInputChange}
                          error={validation.stockDesc || ""}
                          // required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Row className="mb-4">
          <Col className="d-flex justify-content-end" style={{ gap: "12px" }}>
            <button
              type="button"
              className="btnTable"
              style={{ width: "auto", padding: "6px 20px" }}
              onClick={() => handleSubmit("Save")}
              disabled={disabled}
            >
              <i className="bi bi-save"></i> Create
            </button>

            <button
              type="button"
              className="btnTable"
              style={{ width: "auto", padding: "6px 20px" }}
              onClick={() => handleSubmit("Draft")}
              disabled={disabled}
            >
              <i className="bi bi-save"></i> Draft
            </button>
          </Col>
        </Row>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
};
export default CreateStock;
